import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { FaQuoteLeft, FaSync } from 'react-icons/fa';

const MotivationQuote = () => {
  const [quote, setQuote] = useState(null);
  const [dayOfYear, setDayOfYear] = useState(0);

  const quotes = [
    { text: "The future depends on what you do today.", author: "Mahatma Gandhi" },
    { text: "The only way to do great work is to love what you do.", author: "Steve Jobs" },
    { text: "Success is not final, failure is not fatal: it is the courage to continue that counts.", author: "Winston Churchill" },
    { text: "Believe you can and you're halfway there.", author: "Theodore Roosevelt" },
    { text: "It does not matter how slowly you go as long as you do not stop.", author: "Confucius" },
    { text: "Quality is not an act, it is a habit.", author: "Aristotle" },
    { text: "Learning never exhausts the mind.", author: "Leonardo da Vinci" },
    { text: "The expert in anything was once a beginner.", author: "Helen Hayes" },
    { text: "Strive for progress, not perfection.", author: "Unknown" },
    { text: "The beautiful thing about learning is that no one can take it away from you.", author: "B.B. King" },
    { text: "Education is the most powerful weapon which you can use to change the world.", author: "Nelson Mandela" },
    { text: "The mind is not a vessel to be filled, but a fire to be kindled.", author: "Plutarch" },
    { text: "Develop a passion for learning. If you do, you will never cease to grow.", author: "Anthony J. D'Angelo" },
    { text: "The more that you read, the more things you will know. The more that you learn, the more places you'll go.", author: "Dr. Seuss" },
    { text: "Change is the end result of all true learning.", author: "Leo Buscaglia" }
  ];

  useEffect(() => {
    // Get day of year to rotate quotes
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 0);
    const diff = now - start;
    const oneDay = 86400000;
    const day = Math.floor(diff / oneDay);
    setDayOfYear(day);
    setQuote(quotes[day % quotes.length]);
  }, []);

  if (!quote) return null;

  return (
    <Card className="motivation-quote-card mt-4">
      <Card.Body>
        <div className="quote-icon">
          <FaQuoteLeft />
        </div>
        <p className="quote-text">"{quote.text}"</p>
        <p className="quote-author">— {quote.author}</p>
        <div className="quote-footer">
          <small className="text-muted">
            <FaSync className="me-1" size={10} /> Daily motivation
          </small>
        </div>
      </Card.Body>
    </Card>
  );
};

export default MotivationQuote;